var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-group-wrapper"},_vm._l((_vm.tagsToUse),function(tag,index){return _c('ngs-icon',{key:index,attrs:{"tag":tag}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }